import { BrandMark, Button, Spinner } from '@fruuit/ui'
import { RotateCw } from 'lucide-react'

/** Boot screen while the session loads (UI-042: "Opening your workspace…"). */
export function FullPageLoading({ label = 'Opening your workspace…' }: { label?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-dvh flex-col items-center justify-center gap-5 bg-cream px-6"
    >
      <BrandMark className="h-14 animate-fade-in" />
      <p className="flex items-center gap-2.5 text-sm text-sage">
        <Spinner className="text-teal" />
        {label}
      </p>
    </div>
  )
}

export function FullPageError({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-cream px-6 text-center">
      <BrandMark className="h-12" />
      <h1 className="font-display text-xl font-semibold text-ink">
        We couldn't open your workspace
      </h1>
      <p role="alert" className="max-w-md text-sm leading-relaxed text-sage">
        {message}
      </p>
      {onRetry ? (
        <Button variant="secondary" icon={<RotateCw />} onClick={onRetry}>
          Try again
        </Button>
      ) : null}
    </div>
  )
}
